$(document).on('turbo:load', function() {

  $('.advisor-scoreboard-select').change(function() {
    const advisorId = $(this).attr('advisor_id')
    const timeline = $(this).val()
    const component = $('#scoreboard')
    const loadingDots = $(this).closest('.card').find('#brand-scoreboard-loading')
    component.find('.scoreboard-card').remove()
    loadingDots.removeClass('d-none')
    $.get(`/components/scoreboards/sb_advisor?id=${advisorId}&timeline=${timeline}`).done(function(html) {
      setTimeout(() => {
        loadingDots.addClass('d-none')
        component.replaceWith(html);
      }, 500);
    });
  });
});